export default "__VITE_ASSET__CrC0FO4G__"